/* eslint-disable no-inline-styles/no-inline-styles */
/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect, useCallback, useState } from 'react'
import { startOfMonth, addMonths, format, addDays, isSameDay, isSameMonth, endOfMonth, subMonths } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'

import {
  ContainerSmall,
  PickerSmall,
  CalendarDateTopDisplaySmall,
  CalendarDateTopDatesDisplaySmall,
  CalendarDateCenterDisplaySmall,
  CalendarDateContentSmall,
  CalendarDateSquareSmall,
  CalendarDateSquareHeaderSmall,
} from './styles'

function EventsSmallCalendar({ selectedDate, setSelectedDate }) {
  const [period, setPeriod] = useState({
    start: startOfMonth(selectedDate || new Date()),
    end: endOfMonth(selectedDate || new Date()),
  })

  useEffect(() => {
    if (selectedDate) {
      setPeriod({
        start: startOfMonth(selectedDate),
        end: endOfMonth(selectedDate),
      })
    }
  }, [selectedDate])

  const handleNextMonth = () => {
    const nextMonthStart = startOfMonth(addMonths(period.start, 1))
    setSelectedDate(nextMonthStart)
    setPeriod({
      start: nextMonthStart,
      end: endOfMonth(nextMonthStart),
    })
  }

  const handlePreviousMonth = () => {
    const prevMonthStart = startOfMonth(subMonths(period.start, 1))
    setSelectedDate(prevMonthStart)
    setPeriod({
      start: prevMonthStart,
      end: endOfMonth(prevMonthStart),
    })
  }

  const handleDateClick = useCallback((date) => {
    setSelectedDate(date)
  }, [setSelectedDate])

  const grid = 7
  const rows = 5

  return (
    <ContainerSmall>
      <PickerSmall>
        <span>{format(period.start, 'MMMM yyyy', { locale: ptBR })}</span>
        <KeyboardArrowUp stroke="#606162" onClick={handleNextMonth} />
        <KeyboardArrowDown stroke="#606162" onClick={handlePreviousMonth} />
      </PickerSmall>

      <CalendarDateTopDisplaySmall grid={grid}>
        {['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map((day, index) => (
          <CalendarDateTopDatesDisplaySmall key={index}>
            <span>{day}</span>
          </CalendarDateTopDatesDisplaySmall>
        ))}
      </CalendarDateTopDisplaySmall>

      <CalendarDateCenterDisplaySmall>
        <CalendarDateContentSmall grid={grid}>
          {Array.from(Array(rows * grid)).map((_, index) => {
            const date = addDays(period.start, index - period.start.getDay())
            return (
              <CalendarDateSquareSmall key={index} onClick={() => handleDateClick(date)}>
                <CalendarDateSquareHeaderSmall
                  currentMonth={isSameMonth(period.start, date)}
                  currentDay={isSameDay(selectedDate, date)}
                >
                  <span>{format(date, 'd')}</span>
                </CalendarDateSquareHeaderSmall>
              </CalendarDateSquareSmall>
            )
          })}
        </CalendarDateContentSmall>
      </CalendarDateCenterDisplaySmall>
    </ContainerSmall>
  )
}

export default EventsSmallCalendar
